/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";

export const getTopPanelApis = stores => {
  function registerTopPanel(verbId, opts = {}) {
    stores.topPanelStore.registerTopPanelVerbId(verbId, opts);
    return true;
  }

  function setVisibility(value) {
    stores.topPanelStore.setTopPanelVisibility(value);
    return true;
  }

  function setExpandedState(value) {
    stores.topPanelStore.setTopPanelExpandedState(value);
    return true;
  }

  return {
    registerTopPanel,
    setVisibility,
    setExpandedState
  };
};

export const registerTopPanelApis = stores => {
  apiFactory.registerApi(publicApiNames.TOP_PANEL, clientName => getTopPanelApis(stores), true);
};
